import { render, staticRenderFns } from "./xlDevice.vue?vue&type=template&id=1fc4e4da&scoped=true&"
import script from "./xlDevice.vue?vue&type=script&lang=js&"
export * from "./xlDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4e4da",
  null
  
)

export default component.exports